import React from 'react';
const PreviousBtnIcon = (props) => {
    return (React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 5.25H2.8725L7.065 1.0575L6 0L0 6L6 12L7.0575 10.9425L2.8725 6.75H12V5.25Z", fill: (props === null || props === void 0 ? void 0 : props.disabled) ? "#C2C7D0" : "#363948" })));
};
export default PreviousBtnIcon;
